<form [formGroup]="form">
    <mat-form-field appearance="outline">
        <mat-label class="mat-label-background">{{field.label}}</mat-label>
        <input type="text" [placeholder]="field.label" [attr.arialabel]="field.label" matInput [formControlName]="field.control">
    </mat-form-field>
    <div *ngIf="field.helperText" class="helper-text">{{field.helperText}}</div>
</form>
